<template>
  <div>
    <sis-view-dialog
      v-if="sisViewVisible"
      @close="closeSisViewDialog"
      :code="deviceCode"
      :unitCode="unitCode"
      :systemCode="systemCode"
    ></sis-view-dialog>
    <measurement-point-trend-dialog
      v-if="measurementPointTrendVisible"
      :measurePoints="pointTrendData"
      @closeTrendDialog="closeMeasurementPointTrendDialog"
    ></measurement-point-trend-dialog>
  </div>
</template>
<script>
import { formatValue } from '@/utils/basicTool'
import { DevicePointRelationApi } from '@wiz-api/tag-management'
import { isJSONObj } from '../../assets/js/scene/scene'
import SisViewDialog from './DeviceLedger/components/SisViewDialog'
import MeasurementPointTrendDialog from './DeviceLedger/components/MeasurementPointTrendDialog'

const devicePointRelationApi = new DevicePointRelationApi()
const baseUrl = Wiz.GetModuleServer()
const devicePanelConfig = Wiz.globalSettings.globalConfig?.visualizationConfig?.devicePanel || {}
const panelShowDistance = devicePanelConfig.panelShowDistance || 10
const panelUpdateInterval = devicePanelConfig.panelUpdateInterval || 3
const signalR = require('@microsoft/signalr')

let sisConnection = null
let autoDiscount = true
let mpIdMap = {} // 存储所有面板markerId，用于秒级更新(key是pointId)
let pointMarkerIdMap = {} // 存储所有面板markerId,用于更换面板（key是设备编码）
let closeMarkerMap = {} // 面板对应的关闭按钮（key是设备编码）
let detailMarkerMap = {} // 面板对应的详情按钮（key是设备编码）
let sisMarkerMap = {}
let trendMarkerMap = {}
let delPanelTimer = null
const markerImgMap = {
  // 面板展示图片
  detailIcon: {
    color: 'data://apps/gat/img/taizhang.png',
    imgId: '',
  },
  closeIcon: {
    color: 'data://apps/gat/img/icon-close.png',
    imgId: '',
  },
  sisIcon: {
    color: 'data://apps/gat/img/yunxing.png',
    imgId: '',
  },
  trendIcon: {
    color: 'data://apps/gat/img/qushi.png',
    imgId: '',
  },
  title: {
    color: 'data://apps/gat/img/panel-title-green.png',
    imgId: '',
  },
  normal: {
    color: 'data://apps/gat/img/panel-normal-green.png',
    imgId: '',
  },
}
let cameraVisual = {}
export default {
  name: 'DeviceMarker',
  components: { SisViewDialog, MeasurementPointTrendDialog },
  props: {
    player: {
      type: Object,
      required: true,
    },
    isPosition: {
      // 0 所有设备 1 有位置的设备
      type: Number,
      default: 1,
    },
    mode: {
      type: String,
      require: true,
      default: 'visualization'
    }
  },
  watch: {
    mode: {
      handler(newVal) {
        // 进入驾驶舱不需要计算面板位置，进入可视化重新开始计算面板位置
        if (newVal === 'cockpit') {
          clearInterval(this.interval)
        } else if (newVal === 'visualization') {
          this.caculateCurVisual()
        }
      },
    }
  },
  data() {
    return {
      panelSwitchStatus: true, // 面板开关状态
      codeList: [], // 当前可展示的面板列表
      showAll: true, // 是否展示所有面板
      pointMarkerList: [], // 显示的设备标签列表
      sisViewVisible: false,
      measurementPointTrendVisible: false,
      deviceCode: '',
      unitCode: '',
      systemCode: '',
      pointTrendData: [],
    }
  },
  methods: {
    // 设备面板展示判断
    setDisabledPanel(e) {
      const panelSwitchConfig = e.detail.panelSwitchConfig
      // 面板开关配置
      if (panelSwitchConfig) {
        const status = e.detail.status
        this.panelSwitchStatus = status
        const pointMarkerList = this.pointMarkerList
        if (this.showAll || !status) {
          pointMarkerList.forEach((item) => {
            item.disabled = !status
            if (item.disabled && item.show) {
              this.panelShowChange(false, item)
            }
          })
        } else {
          // 开关打开时也只能展示模型中展示了的设备的面板，隐藏了的设备不能展示面板
          pointMarkerList.forEach((item) => {
            if (this.codeList.includes(item.tagCode)) {
              item.disabled = false
            } else {
              item.disabled = true
              if (item.show) {
                this.panelShowChange(false, item)
              }
            }
          })
        }
        this.showNearPanel()
        return
      }

      // 设置可展示面板
      const codeList = e.detail.codeList || []
      const showAll = e.detail.showAll // 展示所有标签
      this.codeList = codeList
      this.showAll = showAll
      // 如果面板开关是关闭的，则不展示
      if (!this.panelSwitchStatus) return
      const pointMarkerList = this.pointMarkerList
      pointMarkerList.forEach((item) => {
        if (showAll) {
          item.disabled = false
        } else if (codeList.includes(item.tagCode)) {
          item.disabled = false
        } else {
          item.disabled = true
          if (item.show) {
            this.panelShowChange(false, item)
          }
        }
      })
    },
    // 每秒对比视角是否变化，变化则重新计算需要展示的面板
    async caculateCurVisual() {
      await this.showNearPanel()
      if (this.interval) {
        clearInterval(this.interval)
      }
      this.interval = setInterval(async () => {
        const cameraVisual1 = await this.player.Native?.Camera.currentParam()
        if (
          cameraVisual1 &&
          JSON.stringify(cameraVisual?.eye) !== JSON.stringify(cameraVisual1?.eye)
        ) {
          this.showNearPanel()
        }
        cameraVisual = cameraVisual1
      }, panelUpdateInterval * 1000)
    },
    // 视角切换停止展示附近的设备面板
    async showNearPanel() {
      let flag = true
      // pointMarkerList 里筛选符合的
      const currentParam = await this.player.Native?.Camera.currentParam()
      const cameraPos = currentParam.eye
      const panelShowChangetasks = []
      for (let i = 0; i < this.pointMarkerList.length; i += 1) {
        const item = this.pointMarkerList[i]
        if (item.pos) {
          const dis = Math.sqrt(
            (item.pos[0] - cameraPos[0]) * (item.pos[0] - cameraPos[0]) +
              (item.pos[1] - cameraPos[1]) * (item.pos[1] - cameraPos[1]) +
              (item.pos[2] - cameraPos[2]) * (item.pos[2] - cameraPos[2])
          )

          if (dis < panelShowDistance && !item.show && !item.disabled) {
            flag = false
            panelShowChangetasks.push(this.panelShowChange(true, item))
            // await this.panelShowChange(true, item)
          } else if (dis > panelShowDistance && item.show) {
            flag = false
            panelShowChangetasks.push(this.panelShowChange(false, item))
            // await this.panelShowChange(false, item)
          }
        }
      }
      await Promise.all(panelShowChangetasks)
      if (!flag) {
        this.delNotCheckMarker()
      }
    },
    // 关闭数据面板
    closePanel(tagCode) {
      const item = this.pointMarkerList.find((i) => {
        return i.tagCode === tagCode
      })
      if (item) {
        this.panelShowChange(false, item)
        this.delNotCheckMarker()
      }
    },
    // 定时删除没有展示的面板marker, 同时重新订阅测点推送
    delNotCheckMarker() {
      // 定时把没有展示的面板删除
      clearTimeout(delPanelTimer)
      delPanelTimer = setTimeout(async () => {
        await this.removeAllDot()

        const notCheckPointMarkerList = this.pointMarkerList.filter((i) => {
          return i.show === false
        })
        const markderIds = []
        for (let i = 0; i < notCheckPointMarkerList.length; i += 1) {
          const notCheckItem = notCheckPointMarkerList[i]
          // 面板
          if (pointMarkerIdMap[notCheckItem.tagCode]) {
            for (let j = 0; j < pointMarkerIdMap[notCheckItem.tagCode].length; j += 1) {
              const marker = pointMarkerIdMap[notCheckItem.tagCode][j]
              markderIds.push(marker.markerId)
            }
            pointMarkerIdMap[notCheckItem.tagCode] = null
            closeMarkerMap[notCheckItem.tagCode] = null
            detailMarkerMap[notCheckItem.tagCode] = null
            sisMarkerMap[notCheckItem.tagCode] = null
            trendMarkerMap[notCheckItem.tagCode] = null
          }
        }
        await this.player.Native.GisMarker.batchDestroy(markderIds)
        const obj = {}
        Object.keys(mpIdMap).forEach((pointId) => {
          mpIdMap[pointId].forEach((markerItem) => {
            if (!markderIds.includes(markerItem.markerId)) {
              if (!obj[pointId]) {
                obj[pointId] = [markerItem]
              } else {
                obj[pointId].push(markerItem)
              }
            }
          })
        })
        mpIdMap = obj

        const BulkAddDto = []
        Object.keys(mpIdMap).forEach((point) => {
          BulkAddDto.push({
            MeasuringPointId: point,
          })
        })
        await sisConnection.invoke('BulkAddDto', BulkAddDto)
      }, 5 * 1000)
    },
    async panelShowChange(val, item) {
      item.show = val
      const { tagPannelInfo, ...tagInfo } = item
      // 面板处理
      if (pointMarkerIdMap[item.tagCode]) {
        const markerOptions = []
        pointMarkerIdMap[item.tagCode].forEach((marker) => {
          markerOptions.push({
            markerId: marker.markerId,
            options: {
              visible: val,
              pos: tagInfo.pos,
            },
          })
        })
        await this.player.Native.GisMarker.batchUpdate(markerOptions)
      } else if (val) {
        const list = tagPannelInfo.tagMarkers || []
        const markerOptions = []
        for (let j = 0; j < list.length; j += 1) {
          const marker = list[j]
          marker.visible = val
          const optionItem = this.handleCreateMarkerOption(marker, tagPannelInfo.width, tagInfo)
          markerOptions.push(optionItem)
        }
        const markerList = await this.player.Native.GisMarker.batchCreate(markerOptions)
        for (let j = 0; j < list.length; j += 1) {
          const marker = list[j]
          this.saveCreateMarkers(marker, tagInfo, markerList[j])
        }
      }
    },
    // 处理创建标签的option
    handleCreateMarkerOption(marker, width, tagInfo) {
      let imgId = ''
      if (marker.isTitle) {
        imgId = markerImgMap.title.imgId
      } else if (marker.isCloseIcon) {
        imgId = markerImgMap.closeIcon.imgId
      } else if (marker.isDetailIcon) {
        imgId = markerImgMap.detailIcon.imgId
      } else if (marker.isSisIcon) {
        imgId = markerImgMap.sisIcon.imgId
      } else if (marker.isTrendIcon) {
        imgId = markerImgMap.trendIcon.imgId
      } else {
        imgId = markerImgMap.normal.imgId
      }
      return {
        pos: tagInfo.pos,
        imgId,
        imgSize: marker.imgSize || [width, marker.height],
        text: marker.content || '',
        nodeOffset: marker.nodeOffset,
        textFontSize: marker.fontSize || 14,
        breakWidth: -1,
        textColor: marker.textColor || 0xffffffff,
        title: null,
        contentPadding: marker.contentPadding,
        visible: marker.visible,
      }
    },
    // 保存创建标签id
    async saveCreateMarkers(marker, tagInfo, markerId) {
      if (pointMarkerIdMap[tagInfo.tagCode]) {
        pointMarkerIdMap[tagInfo.tagCode].push({
          markerId,
          tagCode: tagInfo.tagCode,
          measuringPointId: marker.measuringPointId || '',
        })
      } else {
        pointMarkerIdMap[tagInfo.tagCode] = [
          {
            markerId,
            tagCode: tagInfo.tagCode,
            measuringPointId: marker.measuringPointId || '',
          },
        ]
      }
      // 关闭按钮
      if (marker.isCloseIcon && !closeMarkerMap[tagInfo.tagCode]) {
        closeMarkerMap[tagInfo.tagCode] = {
          markerId,
          tagCode: tagInfo.tagCode,
          type: 'close',
        }
      }

      // 详情按钮
      if (marker.isDetailIcon && !detailMarkerMap[tagInfo.tagCode]) {
        detailMarkerMap[tagInfo.tagCode] = {
          markerId,
          tagName: tagInfo.tagName,
          tagCode: tagInfo.tagCode,
          unit: tagInfo.unit,
          major: tagInfo.major,
          type: 'detail',
        }
      }
      // SIS按钮
      if (marker.isSisIcon && !sisMarkerMap[tagInfo.tagCode]) {
        sisMarkerMap[tagInfo.tagCode] = {
          markerId,
          tagName: tagInfo.tagName,
          tagCode: tagInfo.tagCode,
          unit: tagInfo.unit,
          major: tagInfo.major,
          unitCode: tagInfo.unitCode,
          systemCode: tagInfo.systemCode,
          type: 'sis',
        }
      }
      // 趋势按钮
      if (marker.isTrendIcon && !trendMarkerMap[tagInfo.tagCode]) {
        trendMarkerMap[tagInfo.tagCode] = {
          markerId,
          tagName: tagInfo.tagName,
          tagCode: tagInfo.tagCode,
          unit: tagInfo.unit,
          major: tagInfo.major,
          pointList: tagInfo.pointList,
          type: 'trend',
        }
      }
      if (!marker.measuringPointId) return
      if (mpIdMap[marker.measuringPointId]) {
        mpIdMap[marker.measuringPointId].push({
          markerId,
          pointName: marker.pointName,
          pointCode: marker.pointCode,
          value: marker.value,
          unit: marker.unit,
        })
      } else {
        mpIdMap[marker.measuringPointId] = [
          {
            markerId,
            pointName: marker.pointName,
            pointCode: marker.pointCode,
            value: marker.value,
            unit: marker.unit,
          },
        ]
      }
    },
    // 获取所有有位置信息的设备列表
    async getDeviceList() {
      const res = await axios({
        method: 'GET',
        url: `${baseUrl}/openapi/devices/paged-list/position/V1.0?token=portal_js`,
        headers: {
          'Content-Type': 'application/json; charset=utf8',
        },
        responseType: 'json',
        params: {
          pageNo: 1,
          pageSize: 9999,
          isPosition: this.isPosition,
        },
      })
      if (res && !_.isNil(res.data?.data)) {
        const tempList = res.data.data.items || []
        const pointMarkerList = []
        const codeList = []
        tempList.forEach((item) => {
          codeList.push(item.code)
        })
        // 获取面板列表
        const panelMap = await this.getPointPanelInfos(codeList)
        for (let i = 0; i < tempList.length; i += 1) {
          const item = tempList[i]
          let pos = ''
          if (isJSONObj(item.modulePosition)) {
            pos = JSON.parse(item.modulePosition)
          }
          const device = {
            tagCode: item.code,
            tagName: item.name,
          }

          // if (panelMap[item.code]) {
          item.tagPannelInfo = await this.handlePanelInfo(device, panelMap[item.code] || {}) // 获取显示的测点面板信息
          // }

          pointMarkerList.push({
            tagCode: item.code,
            tagName: item.name,
            unit: item.unit,
            major: item.major,
            tagPannelInfo: item.tagPannelInfo,
            unitCode: item.unitCode,
            systemCode: item.systemCode,
            pointList: panelMap[item.code],
            pos,
            show: false,
            disabled: false,
          })
        }
        this.pointMarkerList = pointMarkerList
        setTimeout(async () => {
          await this.caculateCurVisual()
        }, 1000)
      }
    },
    // 面板列表
    async getPointPanelInfos(codes) {
      const [err, res] = await devicePointRelationApi.batchGetDeviceRelationPoint({
        body: codes,
      })
      if (!err && res) {
        const obj = {}
        res.forEach((item) => {
          obj[item.deviceCode] = item.pointList
        })
        return obj
      }
      return {}
    },
    // 面板测点信息处理
    async handlePanelInfo(device, data) {
      const measurePointList = data.slice(0, 10)
      const deviceName = [
        {
          content: `${device.tagName}`,
          isTitle: true,
          nodeOffset: [0, 0],
          height: 38,
          contentPadding: [12, 15, 0, 0],
          fontSize: 17,
        },
      ]
      const tagMarkers = [
        {
          content: `${device.tagCode}`,
          nodeOffset: [0, 37],
          height: 28,
          contentPadding: [12, 7, 0, 0],
          textColor: 0x44f1ffff,
          fontSize: 15,
        },
      ]
      const markerLen = tagMarkers.length
      measurePointList.forEach((item, idx) => {
        const value = formatValue(item.value)
        tagMarkers.push({
          measuringPointId: item.pointId,
          pointName: item.pointName,
          pointCode: item.pointCode,
          value: item.value,
          unit: item.pointUnit || '',
          content: `${item.pointName}：${value}${item.pointUnit || ''}`,
          nodeOffset: [0, 37 + 26 * (idx + markerLen)],
          height: 28,
          contentPadding: [12, 7, 0, 0],
        })
      })
      const contents = tagMarkers.map((item) => {
        return item.content
      })

      let nameLen = 0
      deviceName[0].content.split('').forEach((char) => {
        if (/[\u4e00-\u9fa5]/g.test(char)) {
          nameLen = nameLen + 19
        } else {
          nameLen = nameLen + 11
        }
      })

      const contentLen = []
      contents.forEach((content) => {
        let len = 0
        content.split('').forEach((char) => {
          if (/[\u4e00-\u9fa5]/g.test(char)) {
            len = len + 16
          } else {
            len = len + 8
          }
        })
        contentLen.push(len)
      })

      let width = Math.max(nameLen, ...contentLen) + 20
      width = width < 180 ? 180 : width
      const otherIcons = [
        // {
        //   isCloseIcon: true, // marker关闭标签
        //   content: '',
        //   nodeOffset: [width - 1, -1],
        //   imgSize: [22, 22],
        //   contentPadding: [0, 0, 0, 0],
        // },
        {
          isDetailIcon: true, // marker详情标签
          content: '',
          nodeOffset: [width - 46 - 48 - 48, -22],
          imgSize: [46, 22],
          contentPadding: [0, 0, 0, 0],
        },
        {
          isSisIcon: true, // markerSis标签
          content: '',
          nodeOffset: [width - 46 - 48, -22],
          imgSize: [46, 22],
          contentPadding: [0, 0, 0, 0],
        },
        {
          isTrendIcon: true, // marker趋势详情标签
          content: '',
          nodeOffset: [width - 46, -22],
          imgSize: [46, 22],
          contentPadding: [0, 0, 0, 0],
        },
      ]
      return {
        width,
        tagMarkers: [...deviceName, ...tagMarkers, ...otherIcons],
      }
    },
    getTextWidth(text, font = '15px Arial') {
      const canvas = document.createElement('canvas')
      const context = canvas.getContext('2d')
      context.font = font
      const metrics = context.measureText(text)
      return Math.ceil(metrics.width) + 20
    },
    // 删除多行文本标记
    delPointMarkers() {
      if (!this.player || !this.player.Native) return
      Object.keys(pointMarkerIdMap).forEach((tagCode) => {
        pointMarkerIdMap[tagCode] &&
          pointMarkerIdMap[tagCode].forEach((marker) => {
            this.player.Native.GisMarker.destroy(marker.markerId)
          })
      })
      pointMarkerIdMap = {}
      closeMarkerMap = {}
      detailMarkerMap = {}
      sisMarkerMap = {}
      trendMarkerMap = {}
      mpIdMap = {}
    },
    // 标记点击
    markerClick(info) {
      const closeMarkerKeys = Object.keys(closeMarkerMap)
      for (let i = 0; i < closeMarkerKeys.length; i += 1) {
        // 关闭面板按钮点击
        const tagCode = closeMarkerKeys[i]
        if (closeMarkerMap[tagCode] && closeMarkerMap[tagCode].markerId === info.markerId) {
          this.closePanel(tagCode)
          return
        }
      }

      const detailMarkerKeys = Object.keys(detailMarkerMap)
      for (let i = 0; i < detailMarkerKeys.length; i += 1) {
        // 详情面板按钮点击
        const tagCode = detailMarkerKeys[i]
        if (detailMarkerMap[tagCode] && detailMarkerMap[tagCode].markerId === info.markerId) {
          this.$emit('transferEvent', {
            toCom: { code: 'DeviceRealBasicInfo', origin: 'DevicePanel', name: '设备基础信息' },
            type: 'mainComponent',
            props: {
              name: detailMarkerMap[tagCode].tagName,
              code: detailMarkerMap[tagCode].tagCode,
              unit: detailMarkerMap[tagCode].unit,
              major: detailMarkerMap[tagCode].major,
            },
          })
          return
        }
      }

      const sisMarkerKeys = Object.keys(sisMarkerMap)
      for (let i = 0; i < sisMarkerKeys.length; i += 1) {
        // sis面板按钮点击
        const tagCode = sisMarkerKeys[i]
        if (sisMarkerMap[tagCode] && sisMarkerMap[tagCode].markerId === info.markerId) {
          this.deviceCode = sisMarkerMap[tagCode].tagCode
          this.unitCode = sisMarkerMap[tagCode].unitCode
          this.systemCode = sisMarkerMap[tagCode].systemCode
          this.sisViewVisible = true
          return
        }
      }

      const trendMarkerKeys = Object.keys(trendMarkerMap)
      for (let i = 0; i < trendMarkerKeys.length; i += 1) {
        // 测点趋势面板按钮点击
        const tagCode = trendMarkerKeys[i]
        if (trendMarkerMap[tagCode] && trendMarkerMap[tagCode].markerId === info.markerId) {
          this.pointTrendData = trendMarkerMap[tagCode].pointList.map((item) => {
            return {
              code: item.pointCode,
              name: item.pointName,
              id: item.id,
              pointId: item.pointId,
            }
          })
          this.measurementPointTrendVisible = true
          return
        }
      }
    },
    // websocket推送更新marker
    async websocketUpdatePanel(list) {
      // const list = [{ measuringPointId: 15153, value: 2 }]
      const markerOptions = []
      list.forEach((item) => {
        const markerList = mpIdMap[item.measuringPointId] || []
        markerList.forEach((marker) => {
          const value = formatValue(item.value)
          marker.value = item.value
          if (marker.markerId) {
            markerOptions.push({
              markerId: marker.markerId,
              options: {
                text: `${marker.pointName}：${value}${marker.unit}`,
              },
            })
          }
        })
      })
      this.player?.Native?.GisMarker.batchUpdate(markerOptions)
    },
    // 清空订阅测点
    async removeAllDot() {
      try {
        await sisConnection.invoke('RemoveAllDto')
      } catch (e) {
        // console.log(e)
      }
    },
    // 建立面板连接
    async initSisConenction() {
      // 建立连接
      const url = `${baseUrl}/iotQueryForJobManageHub`

      sisConnection = new signalR.HubConnectionBuilder()
        .withUrl(url, {
          skipNegotiation: true,
          transport: signalR.HttpTransportType.WebSockets,
        })
        .configureLogging(signalR.LogLevel.Information)
        .build()

      // 监听面板测点信息
      sisConnection.on('MsgResult', (data) => {
        this.websocketUpdatePanel(data)
      })

      sisConnection.onclose(() => {
        if (autoDiscount) {
          setTimeout(() => {
            this.reStartSisConnect()
          }, 5000)
        }
      })

      // 开始连接
      try {
        await sisConnection.start()
      } catch (e) {
        // console.log(e)
      }
    },
    async reStartSisConnect() {
      // 开始连接
      try {
        await sisConnection.start()
        const BulkAddDto = []
        Object.keys(mpIdMap).forEach((point) => {
          BulkAddDto.push({
            MeasuringPointId: point,
          })
        })
        await sisConnection.invoke('BulkAddDto', BulkAddDto)
      } catch (e) {
        setTimeout(() => {
          this.reStartSisConnect()
        }, 5000)
      }
    },
    // 断开socket连接
    async disSisconnect() {
      if (sisConnection) {
        try {
          autoDiscount = false
          await sisConnection.invoke('DisconnectedCurrentHub')
        } catch (e) {
          // console.log(e)
        } finally {
          sisConnection = null
        }
      }
    },
    closeSisViewDialog() {
      this.sisViewVisible = false
    },
    closeMeasurementPointTrendDialog() {
      this.measurementPointTrendVisible = false
    },
  },
  async created() {
    // 创建好报警等级对应的面板颜色
    const keys = Object.keys(markerImgMap)
    const loadImagetask = []
    for (let i = 0; i < keys.length; i += 1) {
      const obj = keys[i]
      const color = markerImgMap[obj].color
      loadImagetask.push(
        this.player.Native.GisMarker.loadImage(color).then((imgId) => {
          markerImgMap[obj].imgId = imgId
        })
      )
    }
    await Promise.all(loadImagetask)
    await this.initSisConenction()

    await this.getDeviceList()
    // Marker标记点击
    this.player.Native.GisMarker.EventGisMarkerLClick.connect(this.markerClick)
    this.$emit('inited')
    window.addEventListener('setDisabledPanel', this.setDisabledPanel)
  },
  beforeDestroy() {
    this.disSisconnect()
    clearInterval(this.interval)
    this.delPointMarkers()
    this.player.Native.GisMarker.EventGisMarkerLClick.disconnect(this.markerClick)
    window.removeEventListener('setDisabledPanel', this.setDisabledPanel)
  },
}
</script>
